import { render, staticRenderFns } from "./ArchiveCardVersionPanel.vue?vue&type=template&id=bbe0f6ac&scoped=true&"
import script from "./ArchiveCardVersionPanel.vue?vue&type=script&lang=ts&"
export * from "./ArchiveCardVersionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ArchiveCardVersionPanel.vue?vue&type=style&index=0&id=bbe0f6ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe0f6ac",
  null
  
)

export default component.exports